import React, { useState } from "react";
import { Input, notification, Form, Col, Row, Button, Modal } from "antd";
import { useMediaQuery } from "react-responsive";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { PlusOutlined, MailFilled } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import SubscriberUserMatchedRecords from "../SubscriberFirm/SubscriberUserMatchedRecords";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};

const SubscriberUserAdd = (props) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const [loading, SetLoading] = useState(false);
  const [values, SetValues] = useState(JSON);
  const [SubscriberUsers, SetSubscriberUsers] = useState({
    data: [],
    loading: true,
  });
  const [visibleUserInfo, SetVisibleUserInfo] = useState(false);
  const [homeOwnerId, SetHomeOwnerId] = useState("");
  const [hirerId, SetHirerId] = useState("");
  const errorList = [];

  const openNotificationWithIconAdd = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Ekleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const onFinish = (values) => {
    SetValues(values);

    RequestHandler.post(
      "/SubscriberUser/CheckUsersExist",
      [
        {
          Email: values.Mail,
          Name: values.Name,
          PhoneNumber: values.Phone,
          TcNo: values.Tckn,
          Vkn: values.Vkn,
          TenantSubscriberUserDto: {
            IsHirer: props.IsHirer,
          },
        },
      ],
      false
    ).then((response) => {
      SetSubscriberUsers({
        data: response,
        loading: false,
      });

      if (response.length != 0) {
        SetVisibleUserInfo(true);
      } else {
        onFinishUserAdd(values);
      }
    });
  };

  const onFinishUserAdd = (values) => {
    RequestHandler.post(`/SubscriberUser`, {
      id:
        homeOwnerId == "" && hirerId == ""
          ? "00000000-0000-0000-0000-000000000000"
          : homeOwnerId != ""
            ? homeOwnerId
            : hirerId,
      Email: values.Mail,
      Name: values.Name,
      PhoneNumber: values.Phone,
      TcNo: values.Tckn,
      Vkn: values.Vkn,
      TenantSubscriberUserDto: {
        IsHirer: props.IsHirer,
        FirmId: props.SubscriberFirmId,
      },
    }, false, { rawResponse: true }).then((res) => {
      if (res.status === 200) {
        openNotificationWithIconAdd("success");
        setTimeout(
          function () {
            window.location.reload();
          }.bind(this),
          2000
        );
      }
    });
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onFinishFailedUserAdd = () => {
    SetLoading(false);
  };

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailedUserAdd}
      >
        <Row>
          {isDesktopOrLaptop && (
            <>
              <Col span={20}>
                <Form.Item
                  label="Adı Soyadı"
                  name="Name"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Adı Soyadı alanını boş bırakmayın",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Telefon Numarası"
                  name="Phone"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                  ]}
                >
                  <PhoneInput
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>
                <Form.Item
                  label="T.C. Kimlik No"
                  name="Tckn"
                  rules={[
                    {
                      min: 11,
                      message: "TcNo 11 karakter olmalıdır.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    autoComplete="off"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="11"
                    onInput={maxLengthCheck}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item label="Vergi Numarası" name="Vkn">
                  <Input
                    type="text"
                    autoComplete="off"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="10"
                    onInput={maxLengthCheck}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="E-Mail"
                  name="Mail"
                  rules={[{ type: "email" }]}
                >
                  <Input type={MailFilled} />
                </Form.Item>
              </Col>
              <Col span={4}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>

              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => SetLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
            </>
          )}
          {isTabletOrMobileDevice && (
            <>
              <Col span={24}>
                <Form.Item
                  label="Adı Soyadı"
                  name="Name"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Adı Soyadı alanını boş bırakmayın",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Telefon Numarası"
                  name="Phone"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                  ]}
                >
                  <PhoneInput
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>
                <Form.Item
                  label="T.C. Kimlik No"
                  name="Tckn"
                  rules={[
                    {
                      min: 11,
                      message: "TcNo 11 karakter olmalıdır.",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    autoComplete="off"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="11"
                    onInput={maxLengthCheck}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item label="Vergi Numarası" name="Vkn">
                  <Input
                    type="text"
                    autoComplete="off"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="10"
                    onInput={maxLengthCheck}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="E-Mail"
                  name="Mail"
                  rules={[{ type: "email" }]}
                >
                  <Input type={MailFilled} />
                </Form.Item>
              </Col>

              <Col span={12}></Col>
              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => SetLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>

              <Col span={6}></Col>
              <Col span={24}></Col>
              <Col span={24}></Col>
            </>
          )}
        </Row>
      </Form>
      <Modal
        title={"Eşleşen Kayıtlar"}
        visible={visibleUserInfo}
        centered={true}
        keyboard={true}
        onOk={() => {
          SetVisibleUserInfo(false);
          onFinishUserAdd(values);
        }}
        onCancel={() => {
          SetVisibleUserInfo(false);
          SetLoading(false);
        }}
        width={1000}
        destroyOnClose={true}
      >
        <SubscriberUserMatchedRecords
          Data={SubscriberUsers.data}
          HomeOwnerId={(homeOwnerId) => SetHomeOwnerId(homeOwnerId)}
          HirerId={(hirerId) => SetHirerId(hirerId)}
        />
      </Modal>
    </div>
  );
};
export default SubscriberUserAdd;
